// extracted by mini-css-extract-plugin
module.exports = {"reviewPage":"members-festival_reviewPage__7b6dR"};